import ACHAccounts from "components/customer/Profile/ACHAccounts";
import useTreasuryAccounts from "hooks/useTreasuryAccounts";
import useMobileMessages from "./useMobileMessages";

const NewTreasuryAccount = () => {
    const { accountsUpdated } = useMobileMessages();

    const {
        data: accounts,
        refetch: refreshAccounts,
        isLoading: isLoadingAccounts
    } = useTreasuryAccounts();

    const updateAccounts = async () => {
        await refreshAccounts();
        accountsUpdated();
    }

    return <div style={{ marginTop: '70px' }}>
        <ACHAccounts
            onAccountCreated={updateAccounts}
            onAccountDeleted={updateAccounts}
            accounts={accounts ?? []}
            isLoadingAccounts={isLoadingAccounts}
            isInWebView
        />
    </div>;
};

export default NewTreasuryAccount;